import React from 'react'
import "./App.css"
import All from "./components/All";

function App() {
  return (
    <>
    <All />
    </>
  )
}

export default App